import { ViewModel } from '../view-model';

export class BatchJob implements ViewModel {
  friendlyTypeNameSingular: string;
  apiRoute: string;

  public batchJobId: string;
  public batchJobType: BatchJobType;
  public status: BatchJobState;
  public description: string;
  public parameters: string;
  public message: string;
  public startedBy: string;
  public queueDate: Date;
  public processStartDate: Date;
  public processEndDate: Date;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.batchJobId = data.batchJobId;
    this.batchJobType = data.batchJobType;
    this.status = data.status;
    this.description = data.description;
    this.parameters = data.parameters;
    this.message = data.message;
    this.startedBy = data.startedBy;
    this.queueDate = data.queueDate;
    this.processStartDate = data.processStartDate;
    this.processEndDate = data.processEndDate;
  }
}

export enum BatchJobType {
  Test = 0,
  MassCriticality = 1,
  SyncJobPlan = 98,
  SyncErpWorkItems = 99,
  SyncErpLocations = 100,
  SyncErpWorkItemStatus = 101,
}

export enum BatchJobState {
  None = 0,
  Queued = 1,
  Processing = 2,
  Complete = 3,
  Failed = 4,
}
